import { useState, useEffect } from "react";
import { apiCallsProfileAdmin } from "../api/calls/profileAdmin";

export const useDeviceManagement = () => {
  const [devices, setDevices] = useState([]);
  const [devicesForTable, setDevicesForTable] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchDevicesForTable(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    setRowsPerPage(newRows);
    setPage(0);
    fetchDevicesForTable(0, newRows);
  }

  const fetchDevicesForTable = async (pageParam = page, rowsParam = rowsPerPage) => {
    const result = await apiCallsProfileAdmin.Actions.GetDevicesForTable(pageParam, rowsParam);

    if (result?.data) {
      setDevicesForTable(result.data);
      setTotalCount(result.total);
    }
  };

  const moveDevice = async (marker, newPos) => {
    const result = await apiCallsProfileAdmin.Actions.MoveDevice(marker.id, newPos.lat, newPos.lng, marker.type);
    if (result.status === 200)
      {
        alert("Μετακινήσατε επιτυχώς την συσκευή.")
        getDevices();
        fetchDevicesForTable();

      }
    else {
      alert("αποτυχία μετακίνησης της συσκευής");
    }
    return result;
  }

  const getDevices = async () => {
    try {
      const result = await apiCallsProfileAdmin.Actions.GetDevices();
      const devices = result.data;
      setDevices(devices);
    } catch (err) {
      console.error("Error fetching devices:", err);
    }
  };

  const updateDevice = async (device) => {
    
    const userConfirmed = window.confirm(
      "Είστε σίγουρος ότι θέλετε να ενημερώσετε τα στοιχεία της συσκευής;"
    );
    
    if (!userConfirmed) {
      return;
    }
    
    const result = await apiCallsProfileAdmin.Actions.UpdateDevice(device);

    if (result.status === 200)
      {
        alert("Η ενημέρωση των δεδομένων της συσκευής ήταν επιτυχής.")
        getDevices();
        fetchDevicesForTable();
        return true;
      }
    else {
      alert("Αποτυχία ενημερώσης των δεδομένων της συσκευής");
      return false;
    }
  }


  const deleteDevice = async (device) => {
    const deviceId = device.id;
    const isGateway = device.type === "gateway";
    const userConfirmed = window.confirm(
      "Είστε σίγουρος ότι θέλετε να διαγράψετε την συσκευή;"
    );
    
    if (!userConfirmed) {
      return;
    }
    const result = await apiCallsProfileAdmin.Actions.DeleteDevice(deviceId, isGateway);
    if (result.status === 200)
      {
        alert("Διαγράψατε επιτυχώς την συσκευή.")
        getDevices();
        fetchDevicesForTable();
        return true;
      }
    else {
      alert("Αποτυχία διαγραφής της συσκευής");
      return false;
    }
  };
  
  const addDevice = async (device) => {
    const userConfirmed = window.confirm(
      "Είστε σίγουρος ότι θέλετε να προσθέσετε την συσκευή;"
    );
    
    if (!userConfirmed) {
      return;
    }

    const result = await apiCallsProfileAdmin.Actions.NewDevice(device);
    if (result.status === 200)
      {
        if (result.data.data === 'Δημιουργήθηκε η συσκευή!')
        {
          alert("Προσθέσατε επιτυχώς την συσκευη");
          getDevices();
          fetchDevicesForTable();
          return true;
        }
        else {
          alert("Αποτυχία προσθήκης της συσκευής, παρακαλούμε συμπλήρωστε τα απαραίτητα πεδία");
          return false;
        }
      }
    else {
      alert("αποτυχία προσθήκης της συσκευής");
      return false;
    }
  }

  useEffect(() => {
    getDevices();
    fetchDevicesForTable();
  }, []);


  return { 
    devices, 
    deleteDevice, 
    addDevice,
    updateDevice,
    moveDevice,
    page,
    rowsPerPage,
    totalCount,
    devicesForTable,
    handleChangePage,
    handleChangeRowsPerPage, 
  };
};